<div class="container">
  <div class="logo b2a">
    <img class="image" src="/assets/logos/4C_Logo_B2A_Claim2018.svg" alt="Back2Action">
    <p class="subline" >{{'LOGIN.logosubline' | translate}}</p>
  </div>

  <app-module>
    <div>{{ 'DELETE.message.part-1' | translate }}</div>
    <div>{{ 'DELETE.message.part-2' | translate }}</div>
  </app-module>
</div>

<app-footer></app-footer>



// WEBPACK FOOTER //
// /codebuild/output/src1521087412/src/client/web-client/src/app/pages/delete/delete.component.html